import { call, put, getContext, takeEvery, select } from 'redux-saga/effects';
import { FormAction as BaseFormAction, SubmissionError } from 'redux-form';
import { ApolloError } from 'apollo-client';
import { Services } from 'init/services';
import { SagaContext } from '../../types/common';
import { languageSelector } from '../../selectors/app';
import { getFormErrors } from '../../utils/formatError';
import { actions } from '../../actions/app';
import { routine } from './actions';
import { FormData } from './constraints';
import * as mutation from './mutation.gql';
import { PasswordResetStartVariables } from './__generated__/PasswordResetStart';

interface FormAction extends BaseFormAction {
  payload: {
    values: FormData;
  };
}

export default function* restoreFormSaga() {
  const apolloClient: Services[SagaContext.ApolloClient] = yield getContext(
    SagaContext.ApolloClient
  );

  yield takeEvery(routine.TRIGGER, function* (action: FormAction) {
    const { values } = action.payload;

    const variables: PasswordResetStartVariables = {
      request: {
        email: values.email.trim(),
        locale: yield select(languageSelector),
        origin: window.location.origin,
      },
    };

    try {
      yield call(apolloClient.mutate, { mutation, variables });
      yield put(routine.success());
      yield put(actions.showPasswordResetSuccessModal(values.email.trim()));
    } catch (e: ApolloError | any) {
      const error = getFormErrors(e);
      yield put(routine.failure(new SubmissionError<FormData>(error)));
    }
  });
}
